import { EmptyState } from "@design-system/EmptyState/EmptyState";

export const ScheduleReviewDisabledBody = () => (
    <EmptyState
        header="Recognition schedules are not enabled for this workspace"
        body="Turn on recognition schedules to review this task."
    />
);
